/**
 * Replace old search terms with new search terms
 *
 * @param  {[string]} oldSearchTerms
 * @param  {[string]} newSearchTerms
 *
 */
const updateSearchTerms = (oldSearchTerms, newSearchTerms) => {
  const searchTermsContainers = document.querySelectorAll(
    '[data-search-terms]',
  );

  searchTermsContainers.forEach((searchTermsContainer) => {
    searchTermsContainer.textContent = searchTermsContainer.textContent.replace(
      oldSearchTerms,
      newSearchTerms,
    );

    searchTermsContainer.classList.add('is-completed');
  });
};

/**
 * Replace old search terms in title with new search terms
 *
 * @param  {[string]} oldSearchTerms
 * @param  {[string]} newSearchTerms
 *
 */
const updatePageTitle = (oldSearchTerms, newSearchTerms) => {
  document.title = document.title.replace(oldSearchTerms, newSearchTerms);
};

/**
 * Replace old search terms in og:title metatag with new search terms
 *
 * @param  {[string]} oldSearchTerms
 * @param  {[string]} newSearchTerms
 *
 */
const updateOGTitle = (oldSearchTerms, newSearchTerms) => {
  const ogTitle = document.head.querySelector('[property="og:title"]');

  if (!ogTitle) return;

  ogTitle.content = ogTitle.content.replace(oldSearchTerms, newSearchTerms);
};

/**
 * Add is-complete class to show search terms
 */
const showSearchTerms = () => {
  const searchTermsContainers = document.querySelectorAll(
    '[data-search-terms]',
  );

  searchTermsContainers.forEach((searchTermsContainer) =>
    searchTermsContainer.classList.add('is-completed'),
  );
};

/**
 * Update facet filter gender value
 */
const updateFacetFilterGenderInput = (value) => {
  const facetFilterGenderField = document.querySelector(
    '[data-facet-filter-gender]',
  );

  if (!facetFilterGenderField) return;

  facetFilterGenderField.value = value;
  facetFilterGenderField.disabled = false;
};

/**
 * Init search terms functions
 */
const initSearchTerms = () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const searchTerms = urlParams.get('q');
  const filterGender = urlParams.get('filter-gender');

  if (!filterGender) {
    showSearchTerms();

    return;
  }

  const newSearchTerms = searchTerms.replace(filterGender, '').trim();

  updateSearchTerms(searchTerms, newSearchTerms);
  updatePageTitle(searchTerms, newSearchTerms);
  updateOGTitle(searchTerms, newSearchTerms);
  updateFacetFilterGenderInput(filterGender);
};

initSearchTerms();
